import { QueryType } from '../apollo/graphqlSchema';
import {
  MAX_BREAKDOWN_GROUPS,
  MAX_DATA_TABLE_BREAKDOWN_GROUPS,
} from '../../config/constants';

const getBreakdownGroupLimit = (queryType: QueryType) => {
  return queryType === QueryType.DataTable
    ? MAX_DATA_TABLE_BREAKDOWN_GROUPS
    : MAX_BREAKDOWN_GROUPS;
};

export default getBreakdownGroupLimit;
